export const PULL_THRESHOLD_PX = 70;
export const PULL_MAX_PX = 120;
/** Damped distance (not raw finger travel) below which the gesture stays invisible and the page scrolls normally. */
export const PULL_REVEAL_PX = 25;

const PULL_RESISTANCE = 0.5;

/** Converts the raw finger travel into the damped, capped distance the indicator is dragged by. */
const resolvePullDistance = (rawDeltaPx: number): number => {
	return Math.min(Math.max(rawDeltaPx, 0) * PULL_RESISTANCE, PULL_MAX_PX);
};

export default resolvePullDistance;
